var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#212121",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 15.2973C6.42857 15.4837 6.35332 15.6624 6.21936 15.7942C6.08541 15.926 5.90373 16 5.71429 16C5.52485 16 5.34316 15.926 5.20921 15.7942C5.07526 15.6624 5 15.4837 5 15.2973C5 12.7605 7.25143 10.7297 10 10.7297C12.7486 10.7297 15 12.7605 15 15.2973C15 15.4837 14.9247 15.6624 14.7908 15.7942C14.6568 15.926 14.4752 16 14.2857 16C14.0963 16 13.9146 15.926 13.7806 15.7942C13.6467 15.6624 13.5714 15.4837 13.5714 15.2973C13.5714 13.5651 11.9857 12.1351 10 12.1351C8.01429 12.1351 6.42857 13.5651 6.42857 15.2973ZM10 10.027C9.0528 10.027 8.14439 9.65685 7.47462 8.99794C6.80485 8.33903 6.42857 7.44536 6.42857 6.51351C6.42857 5.58167 6.80485 4.688 7.47462 4.02908C8.14439 3.37017 9.0528 3 10 3C10.9472 3 11.8556 3.37017 12.5254 4.02908C13.1952 4.688 13.5714 5.58167 13.5714 6.51351C13.5714 7.44536 13.1952 8.33903 12.5254 8.99794C11.8556 9.65685 10.9472 10.027 10 10.027V10.027ZM10 8.62162C10.5683 8.62162 11.1134 8.39952 11.5152 8.00417C11.9171 7.60882 12.1429 7.07262 12.1429 6.51351C12.1429 5.95441 11.9171 5.4182 11.5152 5.02286C11.1134 4.62751 10.5683 4.40541 10 4.40541C9.43168 4.40541 8.88663 4.62751 8.48477 5.02286C8.08291 5.4182 7.85714 5.95441 7.85714 6.51351C7.85714 7.07262 8.08291 7.60882 8.48477 8.00417C8.88663 8.39952 9.43168 8.62162 10 8.62162V8.62162Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/Accounts.398a8d8b.svg";
export { ForwardRef as ReactComponent };